import {Component, ViewChild, OnInit} from '@angular/core';
import { environment } from '../../environments/environment';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { AuthService } from "../auth.service";
import { UtilsService } from "../shared/shared.module";
import { DomSanitizer } from '@angular/platform-browser';
import * as _ from "lodash";


declare let swal:any;

@Component({
  selector: 'app-detail-order',
  templateUrl: './detail-order.component.html',
  styleUrls: ['./detail-order.component.css']
})
export class DetailOrderComponent implements OnInit {
  errors: any = {};
  isLoading: boolean = false;

  order: any = {};
  orderUrl: any = null;

  environment: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private utilsService: UtilsService,
    private authService: AuthService,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.environment = environment;
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      this.utilsService.scrollTop();
    });

    this.route.params.subscribe(params => {
      let id = params['id'];

      var query = "";
      if (this.authService.connectedAs.admin == false)
        query += "?connectedAsId=" + this.authService.connectedAs.id;

      this.http.get(environment.API_PATH + '/product/order/' + id + query, {withCredentials: true})
	    .subscribe(
        data => {
          this.order = data;
          var blob = new Blob([new Uint8Array(data['file'].data)], {type: "application/pdf"});
          this.orderUrl = window.URL.createObjectURL(blob);
          this.orderUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.orderUrl + '#scrollbar=0&amp;view=FitV');
          this.isLoading = false;
        },
        err => {
          var errors = err.error;
          this.isLoading = false;
          if (errors.error) {
            if (errors.error.status === 401) {

              this.router.navigate(['/connexion']);
            } else if (errors.error.status === 403) {
              if (errors.error.details.redirect)
                this.router.navigate([errors.error.details.redirect]);
              else
                this.router.navigate(['connexion']);
            } else if (errors.error.status === 404) {
              this.authService.logout();
            }
            else {
              this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
            }
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }

        })
    })
  }

  goToOrder() {
    this.router.navigate(['administration', 'commandes']);

  }

  validateOrder() {
    var query = "";
    if (this.authService.connectedAs.admin == false)
      query += "?connectedAsId=" + this.authService.connectedAs.id;
    this.isLoading = true;
    this.http.get(environment.API_PATH + '/product/order/validate/' + this.order.id + query , {withCredentials: true})
	  .subscribe(
      data => {
        this.isLoading = false;
        this.utilsService.displayNotif("Le bon de commande a bien été validé", "success");
        this.router.navigate(['../..'], {relativeTo: this.route});
      },
      err => {
        this.isLoading = false;
        if (err.status === 401) {

          this.router.navigate(['/connexion']);
        } else if (err.status === 404) {
          this.utilsService.displayNotif("Cette commande n'existe pas", "danger");
          this.router.navigate(['../..'], {relativeTo: this.route});
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
  }

  confirmRefuse(): void {
    swal({
      title: `Êtes-vous sûr de vouloir refuser la commande de la pharmacie "${this.order.pharmacy.name}" ?`,
      text: "Vous ne pourrez pas revenir en arrière",
      type: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: '#49B0D6',
      cancelButtonColor: '#E74C3C',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then(() => {
      this.refuseOrder()
    }, () => {

    });
  }

  refuseOrder() {
    var query = "";
    if (this.authService.connectedAs.admin == false)
      query += "?connectedAsId=" + this.authService.connectedAs.id;

    this.http.get(environment.API_PATH + '/product/order/refuse/' + this.order.id + query , {withCredentials: true})
	  .subscribe(
      data => {
        this.isLoading = false;
        this.utilsService.displayNotif("Le bon de commande a bien été refusé", "success");
        this.router.navigate(['../..'], {relativeTo: this.route});
      },
      err => {
        this.isLoading = false;
        if (err.status === 401) {

          this.router.navigate(['/connexion']);
        } else if (err.status === 404) {
          this.utilsService.displayNotif("Cette commande n'existe pas", "danger");
          this.router.navigate(['../..'], {relativeTo: this.route});
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/detail-order/detail-order.component.ts